export default __webpack_public_path__ + "static/media/music.3b1f1e22.svg";